<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
export default {
  data() {
    return {
      drawTiming: null,
      cdata: {
        category: ['杭州市', '宁波市', '温州市', '嘉兴市', '湖州市', '台州市', '绍兴市', '金华市', '衢州市', '舟山市', '丽水市'],
        lineData: [8092, 1728, 4045, 8348, 8808, 6097, 1867, 1415, 1844, 1415, 1606],
        barData: [6600, 1500, 3500, 6500, 7000, 5500, 1850, 1399, 1698, 1377, 1544],
        rateData: []
      }
    }
  },
  components: {
    Chart
  },
  mounted() {
    this.drawTimingFn()
  },
  beforeDestroy() {
    clearInterval(this.drawTiming)
  },
  methods: {
    drawTimingFn() {
      this.setData()
      this.drawTiming = setInterval(() => {
        // this.setData()
      }, 6000)
    },
    // 根据自己的业务情况修改
    setData() {
      this.cdata.barData.forEach((item, i) => {
        let rate = item / this.cdata.lineData[i]
        this.cdata.rateData.push(rate.toFixed(2))
      })
    }
  }
}
</script>
